import { openContextModal } from "@mantine/modals";

import { ModalInnerProps } from "./StripeCheckoutModal.tsx";

export const openStripeCheckoutModal = (params: ModalInnerProps & { onClose?: () => void }) => {
	const { onClose, ...innerProps } = params;

	openContextModal({
		modal: "stripeCheckoutModal",
		onClose,
		innerProps: innerProps
		// title: String(getI18n().t("stripe_checkout_modal.title"))
	});
};
